import AxiosClient from "../../../services/axios.services";

class TechnicalKnowledgeServices {
  getTechnicalKnowledge = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_conocimiento_tecnico/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getTechnicalKnowledgeById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_conocimiento_tecnico/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveTechnicalKnowledge = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_conocimiento_tecnico/",data,{
        headers: { "Content-Type": "application/json" },
      }
    );
  editTechnicalKnowledge = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_conocimiento_tecnico/${id}/`,data,{
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteTechnicalKnowledge = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_conocimiento_tecnico/${id}`,{
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new TechnicalKnowledgeServices();
